// extracted by mini-css-extract-plugin
export default {"delivery":"BZzQA1","mobile":"qrertL","tabsWrapper":"PWSmgE","tabs":"y8u7no","headingWrap":"vnUC2T","headingWrapMobile":"ugamEl","header":"PlxKdp"};